module.exports = __webpack_public_path__ + "img/game-console-handheld.33a20d19.svg";